import type { FileUsage } from '@vedalib/editor/lib/files'
import React from 'react'
import { FileTypeEnum } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldFile, FieldInput, FieldSegmented, FormField } from 'components/formKit'
import Divider from 'components/uiKit/Divider'
import { t } from 'services/Translation'
import { chainName } from 'utils/form'

import { OPTIONS, PAGE_ITEMS } from './TestInfoElement.constants'
import type { TestInfoValueFormType, PageItem } from './testInfoTypes'

const SHOW = genElementValueField({
  as: FieldSegmented<boolean>,
  label: t('input.label.show'),
  name: 'show',
  defaultValue: false,
})

const LABEL = genElementValueField({
  as: FieldInput,
  name: 'text',
})

const ICON = genElementValueField({
  as: FieldFile<FileUsage>,
  name: 'icon',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    showSource: true,
    hasObjectFit: true,
    hasAccessibility: true,
  },
})

const TestInfoForm: TestInfoValueFormType = ({ name, element }) => {
  const ITEMS = PAGE_ITEMS[element.value.type]

  return (
    <>
      {ITEMS.map((item) => (
        <TestInfoItem item={item} key={item} name={name} />
      ))}
    </>
  )
}

const TestInfoItem: React.FC<{ name: string; item: PageItem }> = ({ name, item }) => {
  const { title, name: itemName } = OPTIONS[item]

  return (
    <Padding bottom gap sides>
      <span>{title}</span>
      <FormField config={chainName(name, itemName, SHOW)} />
      <FormField config={chainName(name, itemName, LABEL)} />
      <FormField config={chainName(name, itemName, ICON)} />
      <Divider />
    </Padding>
  )
}

export default TestInfoForm
